<template>
    <div id="step-projects" class="fade-in-fwd">
        <div class="row mb-2">
            <div :class="(isCreateProjectAreaActive) ? 'col-md-7' : 'col-md-6'">
                <input v-if="isCreateProjectAreaActive" v-model="newProjectText" @input="setNewProjectText" type="text"
                    class="form-control"
                    :placeholder="$resourceString['myProject.Project.CreateModal.ProjectName.Placeholder']" />
            </div>
            <div class="col-md-6" v-if="!isCreateProjectAreaActive">
                <button class="btn btn-primary add-button float-sm-right" @click="isCreateProjectAreaActive = true">
                    <span class="png-icon png-icon-icons-glyph--ko-plus mr-2"></span> {{
                $resourceString["myProject.Project.NewProject.Title"] }}
                </button>
            </div>
            <div class="col-md-5" v-else>
                <button class="btn btn-primary add-button w-100 d-block" @click="createProject">
                    {{ $resourceString["myProject.Project.CreateModal.CreateProject.Button"] }}
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="input-group border border-light mb-3">

                    <input v-model="searchtext" @input="updateSearchQuery" @keydown.enter="submitSearch" type="search"
                        class="form-control border-0"
                        :placeholder="$resourceString['account.MyProject.SearchField.Placeholder']" />
                    <div class="input-group-prepend">
                        <button tabindex="-1" type="submit" class="btn px-1 p-1" @click="submitSearch">
                            <span class="png-icon png-icon-icons-glyph--k-search"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-2" id="list-of-projects"
            :class="getContentWizardData.allProjects.length > 3 ? 'inspiration-gallery-item-container' : ''"
            v-if="getContentWizardData.allProjects.length > 0">
            <div class="col-sm-4 mt-2" v-for="(item, index) in getContentWizardData.allProjects" :key="index">
                <div @click="selectProject(item)" class="swiper-slide swiper-slide-visible swiper-slide-active mb-2"
                    :class="(item.id == getContentWizardData.chosenProject.id) ? 'my-project-feature-image-active' : ''">
                    <div class="wf-product-quick-view-swatch-slide">
                        <div class="wf-product-quick-view-swatch-slide-image">
                            <img class="room-img-thumb" :src="item.coverPhoto" :alt="item.title || ''"
                                :style="{ backgroundColor: item.coverPhoto ? '' : '#9f9e9e' }" />
                        </div>
                    </div>
                    <div class="medium mb-2 px-2 w-100 text-size-xsmall text-left">
                        {{ item.title }}
                    </div>
                </div>
            </div>
            <pc-load-more v-if="showLoadMore" :load-more="onLoadMore" />
            <div v-if="getContentWizardData.allProjects.length == 0 && !showLoadMore" class="container">
                <p class="">{{ $resourceString["common.NoDataAvailable.Msg"] }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PcProjectsSearch from "./../../../my-projects-page/pc-projects-search.vue";
import PcLoadMore from "../../../common/pc-loading-more.vue";
export default {
    data() {
        return {
            pageNumber: 1,
            isCreateProjectAreaActive: false,
            showLoadMore: true,
            newProjectText: '',
            searchtext: "",
            timeout: null,
        };
    },
    components: {
        PcProjectsSearch,
        PcLoadMore
    },
    computed: {
        ...mapGetters({
            getContentWizardData: "contentWizard/getContentWizardData",
        }),
    },
    created(){
      this.setAllProjects([]);
    },
    mounted() {
        this.fetchAllProjects();
    },
    methods: {
        ...mapActions({
            setContentItem: "contentWizard/setContentItem",
            getAllProjects: "contentWizard/getAllProjects",
            setAllProjects: "contentWizard/setAllProjects",
            selectProject: "contentWizard/selectProject",
            createProjectCall: "myProject/createProject",
            projectAlreadyExistResourceString: "myProject/projectAlreadyExistResourceString",
            resourceString: "myProject/resourceString",
        }),

        updateSearchQuery(e) {
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
              this.submitSearch()
          }, 1000);
      },

        setNewProjectText(e) {
            this.newProjectText = e.target.value;
        },

        async createProject() {
            if (this.newProjectText != '') {
                await this.resourceString(
                    this.$resourceString["myProject.Project.Created.Msg"]
                );
                await this.projectAlreadyExistResourceString(
                    this.$resourceString["myProject.Request.DuplicateName"]
                );
                await this.createProjectCall({
                    "title": this.newProjectText,
                    "description": "",
                    "siteProjectName": "ProjectFeature",
                    "type": 0,
                    "coverImageCroppings": [],
                    "coverImage": {},
                    "croppedBlobs": {},
                    "coverCropImage": "",
                    "culture": null,
                    "accessLevel": null,
                    "tags": [],
                    "isResource": true,
                    "projectType": "",
                    "projectPhase": "",
                    "projectBudget": ""
                }).then(resp => {
                    if (resp == true) {
                        this.pageNumber = 1;
                        this.searchtext = '';
                        this.fetchAllProjects().then(() => {
                            this.getContentWizardData.allProjects.length > 0 && this.selectProject(this.getContentWizardData.allProjects[0]);
                            this.newProjectText = '';
                            this.isCreateProjectAreaActive = false;
                            document.getElementById("list-of-projects").scrollTo(0, 0);
                        });
                    }
                });
            }
        },

        onLoadMore() {
            if (this.getContentWizardData.allProjects.length < this.getContentWizardData.allProjectsTotalCount) {
                this.pageNumber = this.pageNumber + 1;
                this.fetchAllProjects();
            }
            else {
                this.showLoadMore = false;
            }
        },

        submitSearch() {
            this.pageNumber = 1;
            this.fetchAllProjects();
        },

        async fetchAllProjects() {
            return await this.getAllProjects({
                pageNumber: this.pageNumber,
                type: 'Active',
                searchTerm: this.searchtext
            });
        }
    }
};
</script>
